<template>
    <div>

        <div class="columns is-multiline is-centered m-b-20" style="border-bottom:0.8px #ddd solid;">
            <div class="column has-text-centered is-two-thirds">

                <a class="has-text-danger is-size-6"
                @click="deleteCard">
                    <b-icon icon="trash" size="is-small"></b-icon>
                    Delete
                </a>

                <b-field label="Imagen">
                    <b-upload
                    v-model="image"
                    drag-drop
                    @input="encodeImage"
                    >
                        <section class="section" >
                            <div class=" has-text-centered">
                                <p>
                                    <b-icon
                                        icon="upload"
                                        size="is-large">
                                    </b-icon>
                                </p>
                                <p>Arrastra tus imagenes o haz click.</p>
                            </div>
                        </section>
                    </b-upload>
                </b-field>

                <div v-if="image" class="tags">
                    <span
                        class="tag is-primary" >
                        {{image.name}}
                        <button class="delete is-small"
                            type="button"
                            @click="deleteDropFile">
                        </button>
                    </span>
                </div>
            </div>

            <div class="column is-two-thirds">
                <b-field label="Nombre">
                    <b-input
                    required
                    v-model="data.title"
                    >
                    </b-input>
                </b-field>
            </div>

            <div class="column is-two-thirds">
                <b-field label="Website">
                    <b-input
                    required
                    v-model="data.clientWebsite">

                    </b-input>
                </b-field>
            </div>

        </div>

    </div>
</template>

<script>
export default {
    props:{
        data:{
            type:Object,
            default:new Object({})
        },
        isNew:{
            type:Boolean,
            default:false
        },
        index:{
            type:Number,
            default:new Object({})
        }
    },
    data(){
        return{
            image:""
        }
    },
    methods:{
        encodeImage(){
            let reader = new FileReader();
            reader.readAsDataURL(this.image);
            reader.onloadend = (event) => {
                this.data.image = reader.result
            }
        },
        deleteDropFile(){
            this.image = ""
            this.data.image = ""
        },
        deleteCard(){
            this.$emit("deleteElement", {isNew:this.isNew, index:this.index})
        }
    }
}
</script>
